type EmbedKind = "youtube" | "vimeo" | "loom" | "audio-direct" | "video-direct" | "iframe" | "none";

interface ResolvedEmbed {
  kind: EmbedKind;
  src: string;
}

const YT_RE =
  /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,15})/;
const VIMEO_RE = /^(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:video\/)?(\d+)/;
const LOOM_RE = /^(?:https?:\/\/)?(?:www\.)?loom\.com\/share\/([A-Za-z0-9]+)/;
const DIRECT_AUDIO_RE = /\.(mp3|m4a|wav|ogg|flac)(\?|$)/i;
const DIRECT_VIDEO_RE = /\.(mp4|webm|mov)(\?|$)/i;

export function resolveEmbed(url: string, type: string): ResolvedEmbed {
  const trimmed = url.trim();

  const yt = YT_RE.exec(trimmed);
  if (yt) return { kind: "youtube", src: `https://www.youtube.com/embed/${yt[1]}` };

  const vim = VIMEO_RE.exec(trimmed);
  if (vim) return { kind: "vimeo", src: `https://player.vimeo.com/video/${vim[1]}` };

  const loom = LOOM_RE.exec(trimmed);
  if (loom) return { kind: "loom", src: `https://www.loom.com/embed/${loom[1]}` };

  if (DIRECT_AUDIO_RE.test(trimmed) || type === "audio") {
    if (DIRECT_AUDIO_RE.test(trimmed)) return { kind: "audio-direct", src: trimmed };
  }
  if (DIRECT_VIDEO_RE.test(trimmed)) return { kind: "video-direct", src: trimmed };

  return { kind: "none", src: trimmed };
}
